<template>
  <v-dialog
    v-model="internalValue"
    max-width="450"
    persistent
    content-class="rounded-dialog"
  >
    <v-card class="rounded-xl overflow-hidden">
      <!-- Header -->
      <v-card-title class="title_for_modal">
        <v-icon color="white" class="mr-2">mdi-credit-card-outline</v-icon>
        <span>Payment Confirmation</span>
      </v-card-title>

      <v-card-text class="pa-6">
        <div class="dialog-center">
          <!-- BetterPay Logo/Icon -->
          <div class="payment-icon-container mb-4">
            <div class="payment-icon">
              <v-icon color="#ff5252" size="80"
                >mdi-credit-card-multiple</v-icon
              >
            </div>
          </div>

          <!-- Main Message -->
          <div class="main-message mb-3">Continue to Betterpay</div>

          <!-- Description -->
          <div class="description-text mb-4">
            You will be redirected to Betterpay's secure payment page to
            complete your transaction.
          </div>

          <!-- Security Notice -->
          <div class="security-notice">
            <v-icon color="#4caf50" size="16" class="mr-1"
              >mdi-shield-check</v-icon
            >
            <span>Your payment is secured by Betterpay</span>
          </div>
        </div>
      </v-card-text>

      <!-- Action Buttons -->
      <v-card-actions class="pa-0">
        <div class="button-container">
          <v-btn
            color="#e0e0e0"
            class="cancel-btn"
            @click="handleCancel"
            large
            :disabled="processing"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            <span class="cancel-text">Back</span>
          </v-btn>

          <v-btn
            color="#ff5252"
            class="proceed-btn"
            @click="handleProceed"
            large
            :loading="processing"
            :disabled="processing"
          >
            <v-icon left>mdi-arrow-right</v-icon>
            <span class="proceed-text">
              {{ processing ? "Redirecting..." : "Continue to Pay" }}
            </span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BetterPayConfirmationDialog",
  props: {
    value: Boolean,
    processing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.internalValue = val;
    },
    internalValue(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    handleCancel() {
      this.internalValue = false;
      this.$emit("cancel");
    },
    handleProceed() {
      this.$emit("proceed");
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat("ms-MY", {
        style: "currency",
        currency: "MYR",
      }).format(amount);
    },
  },
};
</script>

<style lang="scss" scoped>
.title_for_modal {
  background: linear-gradient(135deg, #f85757, #ff7b7b) !important;
  color: #fff !important;
  text-align: center;
  width: 100%;
  font-weight: 600;
  padding: 24px 16px !important;
  font-size: 18px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-sizing: border-box;
  margin: 0 !important;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.payment-icon-container {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.payment-icon {
  animation: float 3s ease-in-out infinite;
}

.main-message {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  line-height: 1.3;
}

.description-text {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  max-width: 320px;
}

.security-notice {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #4caf50;
  background: #f1f8e9;
  padding: 8px 12px;
  border-radius: 20px;
  margin-top: 8px;
}

.button-container {
  display: flex;
  width: 100%;
}

.cancel-btn,
.proceed-btn {
  flex: 1;
  min-height: 56px !important;
  font-weight: 600;
  border-radius: 0 !important;

  &.cancel-btn {
    border-bottom-left-radius: 12px !important;

    .cancel-text {
      color: #666 !important;
    }
  }

  &.proceed-btn {
    border-bottom-right-radius: 12px !important;

    .proceed-text {
      color: #fff !important;
    }
  }
}

// Animations
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(33, 150, 243, 0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>

<style lang="scss">
.rounded-dialog {
  border-radius: 16px !important;
  overflow: hidden !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
